import getContactUsRow from "../DataDisplayRow/CustomUsRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class ContactUsTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getContactUsRow()
    }
}

let contactUsTable: ContactUsTable | null = null;

export default function getContactUsTable(): ContactUsTable {
    if (contactUsTable === null)
        contactUsTable = new ContactUsTable()
    return contactUsTable
}